import { postmortemApiEndpoint } from "../config";
import { fetchToken } from "./fetchTokenService";
import { loginRequest } from "../auth/authConfig";
import { getConsumerKey } from "./maerskApiTokenService";

export async function fetchIncidentMetadata(incidentId, instance, accounts) {
  const tokenResponse = await fetchToken(instance, loginRequest, accounts);

  const response = await fetch(
    `${postmortemApiEndpoint}/metadata/${encodeURIComponent(incidentId)}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${tokenResponse.idToken}`,
        "Consumer-Key": getConsumerKey(),
        "Content-Type": "application/json",
      },
    }
  );

  if (response.status === 404) {
    return null;
  }

  if (!response.ok) {
    throw new Error(`metadata API error: ${response.status}`);
  }

  return response.json();
}
